import { ensureLoggedOut, isLoggedIn } from '@/state/Authentication'

import store from '../store/store'

export function injectCart({ cartId, orderId }: { cartId?: string; orderId?: string }): Promise<void> | void {
  if (cartId) {
    if (isLoggedIn()) {
      // Try authenticated injection first. If the logged-in user doesn't own this cart, log out and retry as public identity.
      return store.dispatch('Cart/injectOwnCart', cartId).catch((error) => {
        if (error.response?.status === 404) {
          return ensureLoggedOut().then(() => store.dispatch('Cart/inject', cartId))
        }
        throw error
      })
    }
    return store.dispatch('Cart/inject', cartId)
  }

  if (orderId) {
    // Only used for rescheduling tickets with a price increase '/manage/:orderId/confirm' (CheckoutRoute).
    // '/manage/:orderId' (EditOrderRoute) already has `ensureLoggedOut()` so by the time they reach the CheckoutRoute
    // they will already be logged out.
    return ensureLoggedOut().then(() => store.dispatch('Cart/injectOrder', orderId))
  }
}
